const art_dir = "artworks";
export const ARTWORKS = [
    {
        "image" : "./" + art_dir + "/chopper.png",
        "caption" : "Chopper from One Piece",
        "year" : 2023,
        "month" : 4
    },
    {
        "image" : "./" + art_dir + "/mapo.png",
        "caption" : "Mapo Tofu from Shokugeki no Soma",
        "year" : 2021,
        "month" : 10
    },
    {
        "image" : "./" + art_dir + "/nishi.png",
        "caption" : "Shōko Nishimiya from Koe no Katachi",
        "year" : 2023,
        "month" : 4
    },
    {
        "image" : "./" + art_dir + "/marin.png",
        "caption" : "Marin from My Dress-Up Darling",
        "year" : 2023,
        "month" : 11
    },
    {
        "image" : "./" + art_dir + "/mountain_notebook.jpg",
        "caption" : "Notebook painting of an original mountain landscape",
        "year" : 2024,
        "month" : 1
    }
]